interface PaginationProps {
  page: number
  totalPages: number
  totalCount: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange: (size: number) => void
}

const PAGE_SIZE_OPTIONS = [25, 50, 100, 200]

export function Pagination({
  page,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) {
  const startItem = (page - 1) * pageSize + 1
  const endItem = Math.min(page * pageSize, totalCount)

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 'var(--spacing-md)',
      borderTop: '1px solid var(--color-border)',
      backgroundColor: 'var(--color-bg-secondary)',
    }}>
      <div style={{ color: 'var(--color-text-secondary)' }}>
        Showing {startItem}-{endItem} of {totalCount} rows
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-sm)' }}>
          <span style={{ color: 'var(--color-text-secondary)' }}>Rows per page:</span>
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            style={{ width: '80px' }}
          >
            {PAGE_SIZE_OPTIONS.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-xs)' }}>
          <button
            className="btn btn-secondary"
            onClick={() => onPageChange(1)}
            disabled={page === 1}
            style={{ padding: 'var(--spacing-xs) var(--spacing-sm)' }}
          >
            First
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
            style={{ padding: 'var(--spacing-xs) var(--spacing-sm)' }}
          >
            Prev
          </button>

          <span style={{
            padding: 'var(--spacing-xs) var(--spacing-sm)',
            color: 'var(--color-text-secondary)',
          }}>
            Page {page} of {totalPages || 1}
          </span>

          <button
            className="btn btn-secondary"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
            style={{ padding: 'var(--spacing-xs) var(--spacing-sm)' }}
          >
            Next
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => onPageChange(totalPages)}
            disabled={page >= totalPages}
            style={{ padding: 'var(--spacing-xs) var(--spacing-sm)' }}
          >
            Last
          </button>
        </div>
      </div>
    </div>
  )
}
